import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import ModalTarifasVehiculos from './ModalTarifasVehiculos';
import Alert from 'react-s-alert';
import store from '../../store';
const database=firebase.database();


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};

class TarifasVehiculos extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			tarifas_vehiculos:[],
			tarifa:'',
			tipo_vehiculo:'',
			isActive:false,
			template:false
		};
		
		this.tarifasRef=database.ref().child('Tarifas_Vehiculos');
		this.handleClick=this.handleClick.bind(this);
		this.toggleModal=this.toggleModal.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.updateRow=this.updateRow.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
	}
	
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	handleClickClose(){		
		this.updateRow();		
	}
	
	componentDidMount(){
		
		this.tarifasRef.on('value',this.gotData,this.errData);
	}
	
	componentWillMount(){
		
		
		
	}
	
	
	updateRow(){
		
		
		let cinco=this.cinco.value;
		let diez=this.diez.value;
		let quince=this.quince.value;
		let masquince=this.masquince.value;
		
		
		this.tarifasRef.child(this.state.key_tarifa).update({
			
					d_5km:cinco,
					d_10km:diez,
					d_15km:quince,
					mas_15km:masquince
			
		})
	
		Alert.success('Datos guardados correctamente', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000
						
		});
		this.toggleModal();
		
	}
	gotData=(data)=>{
		
		let newTarifa=[];
		
		let datatarifas=data.val();
		
		if(datatarifas!=null){
			
			let keys=Object.keys(datatarifas);
			
			
			for(let i=0;i<keys.length;i++){
				
					const k=keys[i];
			
					newTarifa.push({
						key:k,
						d_5km:datatarifas[k].d_5km,
						d_10km:datatarifas[k].d_10km,
						d_15km:datatarifas[k].d_15km,
						mas_15km:datatarifas[k].mas_15km
												
					});				
			}
			this.setState({tarifas_vehiculos:newTarifa});
		}
		
	}
	errData=(err)=>{
		
		console.log(err)
		
	}
	
	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}}>Editar</button>;
	}
	
	
	handleClick(row){
		
		
		this.setState({
			key_tarifa:row.key,
			d_5km:row.d_5km,
			d_10km:row.d_10km,
			d_15km:row.d_15km,
			mas_15km:row.mas_15km
					
		})
		
		
		this.toggleModal();
		
		
	}
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
			
		});
				
	}
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	
	render(){
		
		return(
		
				<div className="tarifas_vehiculos container" onClick={this.ocultarMenu}>
					
					<h1 className="titulo">Tarifas por servicio</h1>
						
					{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}
		   			 <ModalTarifasVehiculos/>
					  <BootstrapTable data={ this.state.tarifas_vehiculos }
						 ref='table'			 
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='key' dataSort={true}>Tipo Vehiculo</TableHeaderColumn>
						 <TableHeaderColumn dataField='d_5km' dataSort={true}>5 Km</TableHeaderColumn>
						 <TableHeaderColumn dataField='d_10km' dataSort={true}>10 Km</TableHeaderColumn>
						 <TableHeaderColumn dataField='d_15km' dataSort={true}>15 Km</TableHeaderColumn>
						 <TableHeaderColumn dataField='mas_15km' dataSort={true}>Mayor 15Km</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
					  </BootstrapTable>
							
					
			<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>
						
					
						<form method="POST" action="" onSubmit={this.handleClickAlerta}>
						
						
							<h3>Modificar Tarifa</h3>
							<hr/>
							<div className="form-group">
								<label htmlFor="cincoKilometros">5km</label>
								<input type="text" className="form-control"
								 ref={input => {this.cinco=input;}}	
								 placeholder="Costo 5km" required
								 defaultValue={this.state.d_5km}
								 autoComplete="off"
								/>								
							</div>
							<div className="form-group">
								<label htmlFor="cincoKilometros">10km</label>
								<input type="text" className="form-control"
								 ref={input => {this.diez=input;}}	
								 placeholder="Costo 10km" required
								 defaultValue={this.state.d_10km}
								 autoComplete="off"
								/>								
							</div>
							<div className="form-group">
								<label htmlFor="cincoKilometros">15km</label>
								<input type="text" className="form-control"
								 ref={input => {this.quince=input;}}	
								 placeholder="Costo 15km" required
								 defaultValue={this.state.d_15km}
								 autoComplete="off"
								/>								
							</div>
							<div className="form-group">
								<label htmlFor="cincoKilometros">Mayor a 15Km</label>
								<input type="text" className="form-control"
								 ref={input => {this.masquince=input;}}	
								 defaultValue={this.state.mas_15km}
								 placeholder="Costo mass15km" required
								 autoComplete="off"
								/>								
							</div>
							<hr/>
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
			</Modal> 

				
				</div>		
				
				
				
		);
	}
}
export default TarifasVehiculos;


// WEBPACK FOOTER //
// ./src/Components/Tarifas/TarifasVehiculos.js